import React from "react";
import styled from "styled-components";

const Space = ({ children, height, width, ...props }) => {
    return (
        <SpaceEle $height={height} $width={width} {...props}>
            {children}
        </SpaceEle>
    );
};

const SpaceEle = styled.div`
  height: ${props => props.$height}px;
  width: ${props => props.$width}px;
  flex-shrink: 0;
`;

SpaceEle.defaultProps = {
    $height: 10,
    $width: 10,
}

export default Space;